import CopyButton from '../../shared/CopyButton'

export default class TargetCopyButton extends React.PureComponent
  MIN_BYTESIZE_FOR_WATERMARK = 400 # minimum number of chars in the target to consider applying a watermark
  COPY_PASTE_CAMPAIGN_URL    = "https://neurooo.com/?utm_campaign=copy-paste"
  
  constructor: (props) ->
    super(props)

    # Reference to the child Copy Button, so that we can forward a call to its 'showSuccessPopover' method
    @copyButtonRef = React.createRef();

    @copyTargetToClipboard = @copyTargetToClipboard.bind(this)

  componentDidMount: ->
    window.TargetCopyButton = @ # to be able to call `window.TargetCopyButton.showSuccessPopover()` from outside (Ctrl-C shortcut)

  targetText: ->
    @props.targets.join('')

  watermarkNeeded: (text) ->
    targetByteSize = new Blob([text]).size
    !@props.currentUser?.isPro && targetByteSize >= MIN_BYTESIZE_FOR_WATERMARK

  # Contain both ".text" and ".html" watermarks
  watermark: ->
    if @props.proofreading
      @props.i18n.improvedWith
    else
      @props.i18n.translatedWith

  watermarkText: ->
    @watermark().text

  watermarkHtml: ->
    @watermark().html

  clipboardItemSupported: ->
    typeof ClipboardItem != 'undefined'

  copyTargetToClipboard: ->
    text = @targetText()
    html = text.replace(/\n/g, '<br>')

    if @watermarkNeeded(text)
      text += "\n\n[#{@watermarkText()}]"
      html += "<br/><br/><i>#{@watermarkHtml()}</i>".replace("%{copy_paste_campaign_url}", COPY_PASTE_CAMPAIGN_URL)

    try
      if @clipboardItemSupported()
        clipboardItem = new ClipboardItem({
          'text/plain': new Blob([text], { type: 'text/plain' })
          'text/html':  new Blob([html], { type: 'text/html'  })
        })

        await navigator.clipboard.write([clipboardItem])
      else
        await navigator.clipboard.writeText(text)
    catch error
      window.alert(@props.i18n.clipboardErrorAlert)

      Bugsnag.notify(error) # TODO: remove this once we have identified which browsers can cause an error

  showSuccessPopover: ->
    @copyButtonRef.current.showSuccessPopover() if @copyButtonRef.current

  render: ->
    # Always rendered, but not always visible, to allow a poping-out CSS animation when made visible
    buttonVisible = !@props.loading && @targetText().length

    if @props.proofreading
      initialText = @props.i18n.proofreading
    else
      initialText = @props.i18n.translation
    
    <CopyButton ref={@copyButtonRef}
                className="target-copy"
                initialText={initialText}
                successText={@props.i18n.success}
                buttonVisible={buttonVisible}
                onClick={@copyTargetToClipboard} />
